import React from "react";

const FieldHelp = ({ id, text, className }) => (
  <span
    className={`field-help ${className || ""}`.trim()}
    tabIndex={0}
    role="button"
    aria-describedby={id}
  >
    <i className="zmdi zmdi-info-outline" aria-hidden="true" />
    <span id={id} role="tooltip" className="field-help-tooltip">
      {text}
    </span>
  </span>
);

export default FieldHelp;
